import { combineEpics, ofType } from "redux-observable"
import { map, switchMap } from "rxjs/operators"
import { from } from "rxjs"
import { Epic } from "../../epics"

import * as actions from "./actions"
import { setTitle as setDocumentTitle } from "../../util/Document"
import { IContent } from "./index"

export const requestContentEpic: Epic = (
    action$,
    _state$,
    { tutorial: { tutorialAPI } },
) =>
    action$.pipe(
        ofType(actions.REQUEST_CONTENT),
        switchMap(() => from(tutorialAPI.getContent())),
        map((content: IContent) => {
            setDocumentTitle(content.title)
            return actions.receiveContent(content)
        }),
    )

export default combineEpics(requestContentEpic)
